"use client";

import { useState } from "react";
import Icon from "../../../components/ui/AppIcon";

interface SortDropdownProps {
  selectedSort: string;
  onSortChange: (sort: string) => void;
}

const SortDropdown = ({ selectedSort, onSortChange }: SortDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const sortOptions = [
    { value: "relevance", label: "Most Relevant", icon: "SparklesIcon" },
    { value: "rating", label: "Highest Rated", icon: "StarIcon" },
    { value: "reviews", label: "Most Reviewed", icon: "ChatIcon" },
    { value: "distance", label: "Nearest First", icon: "LocationMarkerIcon" },
  ];

  const currentSort =
    sortOptions.find((opt) => opt.value === selectedSort) || sortOptions[0];

  return (
    <div data-component-id="src/app/category-listings/components/SortDropdown.tsx:25:4" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="25" data-component-end-line="81" data-component-file="SortDropdown.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
      <button data-component-id="src/app/category-listings/components/SortDropdown.tsx:26:6" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="26" data-component-end-line="45" data-component-file="SortDropdown.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%20px-4%20py-2.5%20bg-muted%20rounded-lg%20hover%3Abg-opacity-80%20transition-all%20duration-300%22%7D"
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center space-x-2 px-4 py-2.5 bg-muted rounded-lg hover:bg-opacity-80 transition-all duration-300"
      >
        <Icon data-component-id="src/app/category-listings/components/SortDropdown.tsx:30:8" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="30" data-component-end-line="35" data-component-file="SortDropdown.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22SortAscendingIcon%22%2C%22className%22%3A%22text-muted-foreground%22%7D"
          name="SortAscendingIcon"
          size={18}
          variant="outline"
          className="text-muted-foreground"
        />
        <span data-component-id="src/app/category-listings/components/SortDropdown.tsx:36:8" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="36" data-component-end-line="38" data-component-file="SortDropdown.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-body%20text-sm%20text-foreground%22%2C%22textContent%22%3A%22Sort%3A%22%7D" className="font-body text-sm text-foreground">
          Sort: {currentSort.label}
        </span>
        <Icon data-component-id="src/app/category-listings/components/SortDropdown.tsx:39:8" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="39" data-component-end-line="44" data-component-file="SortDropdown.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChevronDownIcon%22%7D"
          name="ChevronDownIcon"
          size={16}
          variant="outline"
          className={`text-muted-foreground transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {isOpen && (
        <div data-component-id="src/app/category-listings/components/SortDropdown.tsx:48:8" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="48" data-component-end-line="79" data-component-file="SortDropdown.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20top-full%20right-0%20mt-2%20w-56%20bg-card%20border%20border-border%20rounded-lg%20shadow-md%20overflow-hidden%20z-50%22%7D" className="absolute top-full right-0 mt-2 w-56 bg-card border border-border rounded-lg shadow-md overflow-hidden z-50">
          {sortOptions.map((option) => (
            <button data-component-id="src/app/category-listings/components/SortDropdown.tsx:50:12" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="50" data-component-end-line="77" data-component-file="SortDropdown.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
              key={option.value}
              onClick={() => {
                onSortChange(option.value);
                setIsOpen(false);
              }}
              className={`flex items-center space-x-3 w-full px-4 py-3 hover:bg-muted transition-colors duration-200 ${
                selectedSort === option.value
                  ? "bg-brand-primary bg-opacity-5"
                  : ""
              }`}
            >
              <Icon data-component-id="src/app/category-listings/components/SortDropdown.tsx:62:14" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="62" data-component-end-line="71" data-component-file="SortDropdown.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D"
                name={option.icon as any}
                size={18}
                variant="outline"
                className={
                  selectedSort === option.value
                    ? "text-brand-primary"
                    : "text-muted-foreground"
                }
              />
              <span data-component-id="src/app/category-listings/components/SortDropdown.tsx:72:14" data-component-path="src/app/category-listings/components/SortDropdown.tsx" data-component-line="72" data-component-end-line="76" data-component-file="SortDropdown.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
                className={`font-body text-sm ${selectedSort === option.value ? "font-semibold text-brand-primary" : "text-foreground"}`}
              >
                {option.label}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDropdown;
